if (!customElements.get('fast-simon-recommended-products')) {
  class FastSimonRecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.widgetId = this.dataset.widgetId;
      this.title = this.dataset.title;
      this.quickbuy = this.dataset.quickbuy == 'true' ? '-quickbuy' : '';
      this.activeWidgetId = '';
      this.delegatedListenersBound = false;
    }

    connectedCallback() {
      // below the fold: wait until the section is near the viewport before calling the recs API
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.visibilityObserver.disconnect();
        this.activate();
      }, { rootMargin: '600px 0px' });
      this.visibilityObserver.observe(this.closest('.shopify-section') || this);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    activate() {
      if (!this.widgetId) {
        console.warn('[Fast Simon YMAL] No widget ID configured in section settings.');
        return;
      }
      if (window.FastSimonSDK) {
        this._fetch();
      } else {
        document.addEventListener('fastsimon:ready', () => this._fetch(), { once: true });
      }
    }

    _fetch() {
      window.FastSimonSDK.productRecommendationByWidget({
        productID: this.productId,
        widgetsIDS: [this.widgetId],
        withAttributes: false,
        callback: (response) => {
          const widgetResponse = response?.payload?.[0];
          const widgetPayload = widgetResponse?.payload ?? [];
          const widgetId = String(widgetResponse?.widgetID || '');

          if (!widgetPayload.length) {
            this.closest('.shopify-section')?.classList.add('hidden');
            return;
          }

          this.activeWidgetId = widgetId;

          this.innerHTML = `
            <strong class="h3 text-[28px]">${this.title}</strong>
            <div data-recommended-swiper class="py-8 relative">
              <swiper-carousel
                data-space-between="8"
                data-slides-per-view="4"
                data-slides-per-view-mobile="1.5"
              >
                <div class="swiper-wrapper">
                  ${widgetPayload.map((item, index) => `
                    <div class="swiper-slide" data-fs-rec-product-id="${String(item.id || '')}" data-fs-rec-position="${index + 1}">
                      <intersection-loader
                        data-url="${item.u}"
                        data-section-id="product-tile${this.quickbuy}"
                      ></intersection-loader>
                    </div>
                  `).join('')}
                </div>

                <button
                  class="button-slider absolute left-0 z-[2] top-1/2 transform -translate-x-2 md:-translate-x-1/2 -translate-y-full disabled:hidden"
                  data-prev
                >
                  <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                  </svg>
                </button>

                <button
                  class="button-slider absolute right-0 z-[2] top-1/2 transform translate-x-2 md:translate-x-1/2 -translate-y-full disabled:hidden"
                  data-next
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                  </svg>
                </button>
              </swiper-carousel>
            </div>
          `;

          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: 'Fast Simon YMAL Shown' });

          this.reportProductsShown(widgetPayload, widgetId);
          this.addDelegatedEventListeners();
        }
      });
    }

    reportProductsShown(products, widgetId) {
      if (!window.FastSimonSDK || !window.FastSimonEventName) return;
      if (!widgetId) return;

      try {
        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.RecommendationsProductsShown,
          data: {
            products,
            widget_id: widgetId,
            sourceProductID: String(this.productId)
          }
        });
      } catch (e) {}
    }

    addDelegatedEventListeners() {
      if (this.delegatedListenersBound) return;
      this.delegatedListenersBound = true;

      this.addEventListener('click', (event) => {
        const clickedElement = event.target;
        if (!(clickedElement instanceof Element)) return;

        const trackingContainer = clickedElement.closest('[data-fs-rec-product-id][data-fs-rec-position]');
        if (!trackingContainer) return;

        const clickedAnchor = clickedElement.closest('a[href]');
        if (!clickedAnchor) return;

        const recommendedProductId = String(trackingContainer.getAttribute('data-fs-rec-product-id') || '');
        const recommendedPosition = Number(trackingContainer.getAttribute('data-fs-rec-position'));

        if (!recommendedProductId || !Number.isFinite(recommendedPosition) || recommendedPosition <= 0) return;
        if (!this.activeWidgetId) return;
        if (!window.FastSimonSDK || !window.FastSimonEventName) return;

        event.preventDefault();

        try {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.RecommendationProductClicked,
            data: {
              productID: recommendedProductId,
              position: recommendedPosition,
              sourceProductID: String(this.productId),
              widget_id: String(this.activeWidgetId)
            }
          });
        } catch (e) {}

        window.location.href = clickedAnchor.href;
      });
    }
  }

  customElements.define('fast-simon-recommended-products', FastSimonRecommendedProducts);
}
